import React, { useState } from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Button } from 'js/design_system/Button';
import { FollowableUser, News, NewsStory } from 'js/social/shared/types';
import ImpressionWatcher from 'js/utils/impressions/ImpressionWatcher';
import { MultiPaperModal } from './MultiPaperModal';
import { ImpressionPropsGenerator } from '../ImpressionHelper';

const Container = styled.div`
  word-break: break-word;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  align-self: stretch;

  gap: var(--spacing-sm-32, 32px);

  background: var(--feed-news-finding-card-inner-cntr-Color, #dcf2f6);
  padding: var(--spacing-sm-24, 24px);

  @include for-tablet-sm-up {
    background: var(--feed-news-finding-card-inner-cntr-Color, #dcf2f6);
    padding: var(--spacing-sm-32, 32px);
  }
`;

const ContentAndButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;
`;

const Heading = styled(Body)`
  font-weight: 800;
  padding-bottom: 8px;
`;

const NewsBody = styled(Body)``;

type Props = {
  newsStory: NewsStory;
  impressionPropsGen: ImpressionPropsGenerator;
  props: ModalProps;
};

type ModalProps = News & {
  getUserData: (id: number) => FollowableUser;
  index: number;
};

const MultiPaperStoryContainer: React.FunctionComponent<Props> = ({
  newsStory,
  impressionPropsGen,
  props,
}) => {
  const { heading, body, papers } = newsStory;

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const modal = (
    <MultiPaperModal
      open={showModal}
      onClose={handleCloseModal}
      heading={heading}
      body={body}
      papers={papers ?? []}
      impressionPropsGen={impressionPropsGen}
      props={props}
    />
  );

  const content = (
    <>
      <ContentAndButtonsContainer>
        <ContentContainer>
          <ImpressionWatcher {...impressionPropsGen()()('story-body')}>
            {heading && <Heading size="lg">{heading}</Heading>}
            {body && <NewsBody size="lg">{body}</NewsBody>}
          </ImpressionWatcher>
        </ContentContainer>
      </ContentAndButtonsContainer>
    </>
  );

  const paperSetInteractions = (
    <>
      <ImpressionWatcher {...impressionPropsGen()()('view-studies-button')}>
        <Button size="xs" icon="description" onClick={handleOpenModal}>
          View Studies
        </Button>
      </ImpressionWatcher>
    </>
  );

  return (
    <Container>
      {modal}
      {content}
      {paperSetInteractions}
    </Container>
  );
};

export default MultiPaperStoryContainer;
